<template>
  <div class="work_tab">
    <div style="width: 95%; margin: auto">
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="创建时间：">
            <el-date-picker
              clearable
              v-model="formInline.time"
              type="datetimerange"
              align="center"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="接诊状态：">
            <el-select
              v-model="formInline.region"
              placeholder="接诊状态"
              clearable
            >
              <el-option
                v-for="item in order_status"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="患者姓名：">
            <el-input
              clearable
              v-model="formInline.user"
              placeholder="请输入患者姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-tabs v-model="auditName" @tab-click="auditClick">
          <el-tab-pane label="初审审核" name="0"> </el-tab-pane>
          <el-tab-pane label="复审审核" name="1"></el-tab-pane>
        </el-tabs>
        <el-radio-group v-model="activeName" @change="handleClick">
          <el-radio-button label="0"> 待审核</el-radio-button>
          <el-radio-button label="1">审核中</el-radio-button>
          <el-radio-button label="2">审核通过 </el-radio-button>
          <el-radio-button label="3"> 审核未通过</el-radio-button>
        </el-radio-group>
        <PatientItem
          :patientList="dataList"
          @refresh-item="refresh"
        ></PatientItem>
        <el-pagination
          @current-change="currentPageChange"
          :page-size="pageList.pageSize"
          :current-page="pageList.currentPage"
          layout="total, prev, pager, next"
          :total="totalCount"
          style="text-align: center"
        ></el-pagination>
      </div>
    </div>
    <!-- <Vfooter /> -->
  </div>
</template>

<script>
import axios from "axios";
import util from "@/utils";
import MyDiagnosis from "../../components/myDiagnosis/index";
import PlatDiagnosis from "../../components/platDiagnosis/index";
import UserInfo from "../../components/userInfo/index";
import ListInfo from "../../components/listInfo/index";
import VAppointment from "./children/appointment";
import VConsultation from "./children/consultation";
import Vfooter from "@/components/footer/index.vue";
import PatientItem from "./children/patientItem.vue";
import { getOrderList } from "@/api/index.js";

export default {
  name: "userinfo",
  data() {
    return {
      totalCount: 0,
      formInline: {},
      activeName: "0",
      dataList: [],
      pageList: {
        pageSize: 12,
        currentPage: 1,
      },
      order_status: [
        {
          value: "0",
          name: "全部",
        },
        {
          value: "1",
          name: "待支付",
        },
        {
          value: "2",
          name: "待接诊",
        },
        {
          value: "3",
          name: "待确认",
        },
        {
          value: "4",
          name: "待评价",
        },
        {
          value: "5",
          name: "已完成",
        },
        {
          value: "6",
          name: "退款中",
        },
        {
          value: "7",
          name: "已退款",
        },
        {
          value: "8",
          name: "已取消",
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      superMan: "p2p-21232f297a57a5a743894a0e4a801fc3",
      // activeName: "prescription",
      form: [],
      userInfo: {},
      isCurTab: 1,
      curTabUrl: "/index/work/consultation",
      auditName: 0,
    };
  },
  components: {
    VAppointment,
    VConsultation,
    ListInfo,
    MyDiagnosis,
    PlatDiagnosis,
    PatientItem,
    UserInfo,
    Vfooter,
  },
  watch: {
    // 更新页面所在位置，用于判断是前进页还是后退页
    $route(to, from) {
      var cur = to.path.split("/")[3];
      switch (cur) {
        case "consultation":
          this.isCurTab = 1;
          break;
        case "patients":
          this.isCurTab = 2;
          break;
        case "appointment":
          this.isCurTab = 3;
          break;
        case "videoment":
          this.isCurTab = 4;
          break;
        default:
          this.isCurTab = 1;
          break;
      }
    },
  },
  computed: {
    sumUnread() {
      let msgList = this.$store.state.sessionlist;
      let unRead = 0;
      msgList.forEach((item) => {
        unRead = unRead + item.unread;
      });
      return unRead;
    },
  },
  created() {
    this.readyIndexForm();
    this.getDoctorInfo();
    this.initPageTab();
    this.readyPatientList();
    if (this.$store.state.isUpdate) {
      this.isUpdatePopup();
    }
    return this.$store.state.sessionlist;
  },

  mounted() {
    window.onresize = () => {
      // 可以防止报错
      this.$refs.MyDiagnosis && this.$refs.MyDiagnosis.resize();
      this.$refs.PlatDiagnosis && this.$refs.PlatDiagnosis.resize();
      // this.$refs.MyDiagnosis.resize();
      // this.$refs.PlatDiagnosis.resize();
    };
  },
  methods: {
    // 接诊
    headldetail(item) {
      console.log(item);
      if (item.channelCode != "budan") {
        if (!item.accid) {
          this.$message({
            showClose: true,
            message: "该会员信息已被删除,无法进行问诊",
            type: "error",
          });
          return;
        }
        let query = {
          sessionId: "p2p-" + item.accid,
          treatId: item.orderNo,
          patientId: item.patientId,
          status: item.status,
          doctorMobile: item.doctorMobile,
          patientName: item.patientName,
          memberId: item.memberId,
        };
        this.$router.push({
          path: "/index/work/chart",
          query,
        });
      } else {
        if (item.showType) {
          this.userDialogVisible.value = true;
        } else {
          const query = {
            sessionId: "p2p-" + 1111111,
            treatId: item.orderNo,
            patientId: item.patientId,
            status: 10002,
            type: "replenishment",
          };
          this.$router.push({
            path: "/index/work/chart",
            query,
          });
        }
      }
    },
    //查看病历
    patientsHandle(item) {
      if (item.patientId == null || item.patientId == "") {
        this.$message({
          showClose: true,
          message: "该病历信息不存在或者已被删除",
          type: "error",
        });
        return;
      }
      let query = {
        casesId: item.patientId,
        orderNo: item.orderNo,
      };
      this.$router.push({
        path: "/index/work/patientDetails",
        query,
      });
    },
    async readyPatientList() {
      try {
        const that = this;
        let startTime;
        let endTime;
        if (that.formInline.time) {
          startTime = that.formInline.time[0];
          endTime = that.formInline.time[1];
        }
        let params = {
          status: that.formInline.region,
          doctorId: util.getStore("user_id"),
          startDate: startTime,
          endDate: endTime,
          currentPage: that.pageList.currentPage,
          pageSize: that.pageList.pageSize,
          patientName: that.formInline.user,
          serviceId: this.activeName,
          auditName: this.auditName,
        };
        let res = await getOrderList(params);
        if (res.code == 1) {
          this.dataList = res.data.dataList;
          this.totalCount = Number(res.data.totalCount);
        } else {
          that.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleClick() {
      this.pageList.currentPage = 1;
      this.readyPatientList();
    },
    auditClick() {
      this.pageList.currentPage = 1;
      this.readyPatientList();
    },
    currentPageChange(page) {
      this.pageList.currentPage = page;
      this.readyPatientList();
    },
    onSubmit() {
      this.pageList.currentPage = 1;
      this.readyPatientList();
    },
    refresh() {
      this.readyPatientList();
    },

    isUpdatePopup() {
      this.$confirm(
        "您的密码已经三个月没有更新了，建议您立即修改密码",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then((btn) => {
          if (btn == "confirm") {
            this.$router.push({
              path: "../user/setup",
              query: {
                cp: 1,
              },
            });
          }
        })
        .catch(() => {
          this.$store.commit("SET_ISUPDATE_FN", false);
        });
    },
    initPageTab() {
      var cur = this.$route.path.split("/")[3];
      switch (cur) {
        case "consultation":
          this.isCurTab = 1;
          break;
        case "patients":
          this.isCurTab = 2;
          break;
        case "appointment":
          this.isCurTab = 3;
          break;
        case "videoment":
          this.isCurTab = 4;
          break;
        default:
          this.isCurTab = 1;
          break;
      }
    },
    //im连接获取session列表
    initEvent() {
      this.$store.dispatch("connect");
      this.$store.dispatch("updateRefreshState");
    },
    //tab点击事件
    tabHandle(tab, url) {
      this.isCurTab = tab;
      this.$router.push({
        path: url,
      });
    },
    //更多
    tabMore() {
      //我的患者
      this.$router.push({
        path: "/index/user/patients",
      });
    },
    /**
     * 获取今日快报和认证接口
     */
    async readyIndexForm() {
      try {
        let res = await getIndexForm({});
        if (res.success) {
          this.form = res.result;
          if (this.form.dateDifference && this.form.dateDifference[0].value) {
            this.$confirm(
              "您的密码已经三个月没有更新了，建议您立即修改密码",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
              }
            ).then((btn) => {
              if (btn == "confirm") {
                this.$router.push({
                  path: "../user/setup",
                  query: {
                    cp: 1,
                  },
                });
              }
            });
          }
        }
      } catch (error) {}
    },
    /**
     * 获取医生信息
     */
    async getDoctorInfo() {
      try {
        let { code, data } = await getDoctorInformation();
        if (code === 1) {
          console.log(data);
          this.userInfo = data;
          this.$store.commit("setProfileStep", data.profileStep);
          this.$store.commit("setStatus", data.status);
          util.setStore(
            "username",
            this.userInfo.familyName + this.userInfo.firstName
          );
        }
      } catch (error) {}
    },
  },
  destroyed() {
    //移除监听器
    window.removeEventListener("onmessageWS", this.getSocketData);
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-card__body {
  padding-bottom: 0px;
}

.work_tab {
  height: 100%;
  min-width: 1200px;
  margin-top: 15px;
  .warpper {
    display: flex;
    width: 100%;
    padding-bottom: 20px;
    background: #f5f6fa;

    .left_box,
    .right_box {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .item {
      margin: 5px;
      .clearfix {
        height: 56px;
        line-height: 56px;
        background: #fff8f3;
        // box-shadow: 0 -4px 10px #ccc;
        text-align: center;
        border-radius: 6px 6px 0 0;
        border: 1px solid #ebeef5;
        border-bottom: none !important;
        .tab_item {
          cursor: pointer;
        }
      }
    }

    .center_box {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .tab_warpper {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      background: #fff8f3;
    }

    .tabActive {
      color: #fc701a !important;
      font-weight: bold;
    }
    .tabActive::after {
      content: "";
      display: block;
      left: 15px;
      width: 50px;
      margin: auto;
      border-bottom: 3px solid #fc701a;
    }
  }

  .con_text {
    height: 740px;
    overflow: auto;
  }
}

.item .el-card {
  box-shadow: none !important;
  border-radius: 0 0 6px 6px;
  border-top: none !important;
}

.clearfix .tab_item {
  margin-top: 0 !important;
}
</style>
